export default __webpack_public_path__ + "static/media/icon-avis.24532721.svg";